import { Heading } from 'components/1-atoms/Heading';
import { ArticleDate } from 'components/2-molecules/Article';

export interface PublicationHeaderProps {
	date: string;
	heading: string;
}

export const PublicationHeader: React.VFC<PublicationHeaderProps> = ({ date, heading }) => {
	return (
		<div>
			{date && <ArticleDate date={date} />}
			{heading && (
				<Heading headingLevel="h1" style="xl">
					{heading}
				</Heading>
			)}
		</div>
	);
};
